import { useAuth } from '../../../lib/providers/authProvider';

import Heart from '../../icons/Heart';
import Program from 'wwg-utilities/dist/collections/program';
import gaDataLayerEvent from '../../../lib/hooks/GA/gaDataLayerEvent';
import useTrainingConnection from '../../../lib/hooks/trainingConnection';

interface SaveButtonProps {
  program: Program;
  region: string;
  small?: boolean;
}

const SaveButton: React.FC<SaveButtonProps> = ({ program, small }) => {
  const { seeker } = useAuth();

  const { connection, handleClick } = useTrainingConnection(
    program,
    seeker,
    null,
  );

  return (
    <button
      onClick={() => {
        gaDataLayerEvent({
          event: 'cta_interaction',
          cta_interaction: 'cta_clicked_saved',
        });
        handleClick();
      }}
      className={`${
        !small ? 'px-4 text-base md:text-xl' : 'px-5 block sm:w-full'
      } py-2 font-base text-white hover:text-save-button flex items-center justify-center rounded-full font-bold bg-save-button hover:bg-white border-2 border-save-button fill-white hover:fill-save-button`}
    >
      <Heart
        className={`${connection && 'fill-inherit'} ${
          small ? 'h-5 w-5 relative left-2.5 sm:static' : 'h-6 w-6 mr-1'
        } mb-0 sm:mb-1 -mx-5`}
      />
      <span
        className={`${
          small ? 'text-sm hidden sm:inline-block' : ' text-base md:text-xl'
        } `}
      >
        {connection ? 'Saved' : 'Save'}
      </span>
    </button>
  );
};

export default SaveButton;
